import styles from './invite-subproject.module.less';
import Input2 from '../../../components/input/input-2/Input2';
import RoundedButtonSecondary from '../../../components/button/rounded-button-secondary/RoundedButtonSecondary';
import { createSubprojectInvite } from './invite-subproject-actions';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { validate } from './invite-model';

export const AddNewSubprojectInvite = ({ show, projectId, onAdd }) => {
    const [currentName, setName] = useState('');
    const [currentEmail, setEmail] = useState('');
    const [errors, setErrors] = useState({});
    const [touched, setTouched] = useState({});

    const dispatch = useDispatch();

    useEffect(() => {
        setName('');
        setEmail('');
        setErrors({});
        setTouched({});
    }, [show]);
    const validateUser = ({ name = currentName, email = currentEmail }) => {
        const errors = validate({ name: name, email: email });
        setErrors(errors);
        return Object.keys(errors).length === 0;
    };
    const createParticipant = () => {
        setTouched({ name: true, email: true });
        if (validateUser({ name: currentName, email: currentEmail })) {
            dispatch(
                createSubprojectInvite({
                    projectId,
                    name: currentName,
                    email: currentEmail,
                })
            ).then((user) => {
                onAdd({ participant: user });
            });
        }
    };

    if (show) {
        return (
            <div className={styles.newForm}>
                <label className={styles.editName}>
                    <Input2
                        title="Navn"
                        value={currentName}
                        onChange={(e) => {
                            setName(e.target.value);
                            validateUser({ name: e.target.value });
                        }}
                        onKeyPress={(e) => {
                            setTouched({ ...touched, name: true });
                            if (e.key === 'Enter') {
                                createParticipant();
                            }
                        }}
                        onBlur={() => setTouched({ ...touched, name: true })}
                        error={touched.name && errors.name}
                    />
                </label>
                <label className={styles.editEmail}>
                    <Input2
                        title="E-post"
                        value={currentEmail}
                        onChange={(e) => {
                            setEmail(e.target.value);
                            validateUser({ email: e.target.value });
                        }}
                        onBlur={() => setTouched({ ...touched, email: true })}
                        onKeyPress={(e) => {
                            if (e.key === 'Enter') {
                                createParticipant();
                            }
                        }}
                        error={touched.email && errors.email}
                    />
                </label>
                <RoundedButtonSecondary onClick={createParticipant} className={styles.saveParticipant}>
                    Lagre
                </RoundedButtonSecondary>
            </div>
        );
    }
    return null;
};
